import { render, staticRenderFns } from "./DerbyRacesTable.vue?vue&type=template&id=2b7e303a&scoped=true&"
import script from "./DerbyRacesTable.vue?vue&type=script&lang=js&"
export * from "./DerbyRacesTable.vue?vue&type=script&lang=js&"
import style0 from "./DerbyRacesTable.vue?vue&type=style&index=0&id=2b7e303a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7e303a",
  null
  
)

export default component.exports